import { hexToOklch, oklchToHex } from '~/lib/oklch'

/** Wave-6 §1 (D2): header surface derivation — every value computed from the tenant
 *  brand color so ANY tenant gets the treatment mechanically. Exact lightness offsets
 *  are the design's tuning knobs (gate-adjustable); the invariants the tests pin are
 *  darker-left / brand-mid / lighter-accent / transparent-fade. */
export function headerGradient(brandHex: string): string {
  const o = hexToOklch(brandHex)
  const left = oklchToHex(Math.max(0, o.l - 0.12), o.c, o.h)
  const right = oklchToHex(Math.min(1, o.l + 0.02), o.c, o.h)
  return `linear-gradient(90deg, ${left} 0%, ${brandHex.toLowerCase()} 55%, ${right} 100%)`
}

/** The 3px bottom accent edge: lightened brand fading out — reads as a highlight,
 *  never a divider. */
export function headerAccent(brandHex: string): string {
  const o = hexToOklch(brandHex)
  const light = oklchToHex(Math.min(1, o.l + 0.25), Math.max(0, o.c - 0.03), o.h)
  const mid = oklchToHex(Math.min(1, o.l + 0.12), o.c, o.h)
  return `linear-gradient(90deg, ${light} 0%, ${mid} 40%, transparent 78%)`
}
